<p-confirmdialog />
<p-toast />
<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">Assets</h1>
          <p class="text-sm text-primary-500">View all of Your Assets</p>
        </div>
      </div>

      <!-- Tabs -->
      <p-tabMenu
        [model]="tabs"
        [activeItem]="activeTab"
        class="mt-4 border-b"></p-tabMenu>
    </div>
    <div class="w-full p-2 m-2">
      <p-table
        #dt2
        dataKey="id"
        stripedRows
        [value]="filtered_assets"
        responsiveLayout="scroll"
        [globalFilterFields]="[
          'name',
          'asset_key',
          'asset_mac_address',
          'asset_type',
          'customer.name',
          'integration.status',
          'integration.lastSeen'
        ]"
        [paginator]="true"
        [(selection)]="selectedAsset"
        [rows]="25"
        selectionMode="single"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[25, 50, 100]">
        <ng-template #caption>
          <div class="pb-4 text-end">
              <p-button icon="pi pi-external-link" label="Export" (click)="dt2.exportCSV()" />
          </div>
      </ng-template>        <ng-template #emptymessage>
          <tr>
            <td colspan="5">No assets found.</td>
          </tr>
        </ng-template>

        <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="integration.name">
              Name
              <p-sortIcon field="integration.name" />
            </th>
            <th pSortableColumn="asset_key">
              Key
              <p-sortIcon field="asset_key" />
            </th>
            <th pSortableColumn="asset_mac_address">
              Mac Address
              <p-sortIcon field="asset_mac_address" />
            </th>
            <th pSortableColumn="name">
              Model
              <p-sortIcon field="name" />
            </th>
            <th pSortableColumn="customer.name">
              Assigned
              <p-sortIcon field="customer.name" />
            </th>
            <th pSortableColumn="integration.status">
              Status
              <p-sortIcon field="integration.status" />
            </th>
            <th pSortableColumn="integration.lastSeen">
              Last Seen
              <p-sortIcon field="integration.lastSeen" />
            </th>
            <th></th>
          </tr>
          <tr>
            <th>
              <p-columnFilter type="text" field="integration.name"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="asset_key"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter
                type="text"
                field="asset_mac_address"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter
                type="text"
                field="integration.name"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter
                type="text"
                field="customer.name"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter
                type="text"
                field="integration.status"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter
                type="text"
                field="integration.lastSeen"></p-columnFilter>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData">
            <td>
              {{ rowData.integration?.name }}
            </td>
            <td>
              {{ rowData.asset_key }}
            </td>
            <td>
              {{ rowData.asset_mac_address }}
            </td>
            <td>
              {{ rowData.name }}
            </td>
            <td>
              {{ rowData.customer?.name }}
            </td>
            <td>
              <span
                [ngClass]="
                  rowData.integration?.status === 'active'
                    ? 'green'
                    : rowData.integration?.status === 'disabled'
                    ? 'orange'
                    : 'red'
                ">
                {{ rowData.integration?.status }}
              </span>
            </td>
            <td>
              {{ rowData.integration?.lastSeen | date : "medium" }}
            </td>
            <td>
              <p-button
                (click)="activeItem = rowData; menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
    </div>
  </block-ui>
  <p-dialog
    header="Assign Asset"
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: '40rem' }">
    <span class="block mb-8 p-text-secondary">Assign subscription to this asset.</span>
    <div class="flex flex-wrap items-center w-full gap-4 mb-4">
      <label for="subscription" class="w-4/12 font-semibold md:w-full">Subscription</label>
      <p-autocomplete
        id="subscription"
        class="w-8/12 md:w-full"
        appendTo="body"
        [(ngModel)]="selectedSubscription"
        optionLabel="name"
        [suggestions]="filteredSubscriptions"
        (completeMethod)="searchSubscriptions($event)">
        <ng-template let-subscription #item>
          <div class="flex flex-wrap w-full">
            <div class="w-full p-2 m-2 md:8/12 top-2">{{ subscription.customer_id?.name }}</div>
            <div class="w-full p-2 m-2 md:4/12">{{ subscription.name }}</div>
          </div>
      </ng-template>
    </p-autocomplete>
    </div>
    <div class="flex justify-end gap-2">
      <p-button label="Cancel" severity="secondary" (click)="visible = false" />
      <p-button label="Save" (click)="assignAsset()" />
    </div>
  </p-dialog>
</div>
